module.exports = __webpack_public_path__ + "static/html-element_3-0dc85d0f5aa196aa30b92e6a96ef79a7.jpg";